import { render, staticRenderFns } from "./app-sidebar-menu.vue?vue&type=template&id=835a65ac&"
import script from "./app-sidebar-menu.vue?vue&type=script&lang=js&"
export * from "./app-sidebar-menu.vue?vue&type=script&lang=js&"
import style0 from "./app-sidebar-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports